import LocalStorageService from '../../services/storage/local-storage-service';
import MatchDetailsPrematchModel from '../../components/widgets/match-details/prematch/model-match-details-prematch';
import MyFavoritesRequestService from '../../services/service-my-favorites';
import ChangeCombiService from '../../services/changeCombi-request-service';
import OddHelperService from '../../services/odd-helper-service';

export const favoritesModule = {
  state: {
    // list of favorite matches Objects
    favorites: [],
    // list of favorite sports
    sports: [],
    // list of favorite categories
    categories: [],
    // list of favorite tournament objects
    tournaments: [],
    // list of favorite matches
    favoriteMatches: [],
    // async flag for keeping track of loading requests
    asyncFlagFavorites: false,
  },
  mutations: {
    updateAsyncFlagFavorites(state, flagObj) {
      state.asyncFlagFavorites = flagObj;
    },
    addFavorite(state, matchIdObj) {
      state.favorites.push(matchIdObj);
    },
    addFavoriteMatch(state, match) {
      if (state.favoriteMatches.some(m => m.matchId === match.matchId)) {
        return;
      }
      state.favoriteMatches.push(match);
    },
    removeFavorite(state, matchId) {
      const index = state.favorites.findIndex(m => m.matchId === matchId);
      if (index > -1) {
        state.favorites.splice(index, 1);
      }
      let findex = -1;
      for (let i = 0; i < state.favoriteMatches.length; i += 1) {
        if (state.favoriteMatches[i].matchId === matchId) {
          findex = i;
          break;
        }
      }
      if (findex > -1) {
        state.favoriteMatches.splice(findex, 1);
      }
    },
    addFavoriteSport(state, sport) {
      state.sports.push(sport);
    },
    addFavoriteTournament(state, tournament) {
      state.tournaments.push(tournament);
    },
    addFavoriteCategory(state, category) {
      state.categories.push(category);
    },
    /**
     * remove sport from favorites list
     * @param sportId selected sport id
     */
    removeFavoriteSport(state, sportId) {
      const index = state.sports.findIndex(s => s.sportId === sportId);
      if (index > -1) {
        state.sports.splice(index, 1);
      }
    },
    /**
     * remove tournament from favorites list
     * @param tournamentId selected tournament id
     */
    removeFavoriteTournament(state, tournamentId) {
      const index = state.tournaments.findIndex(t => t.tournamentId === tournamentId);
      if (index > -1) {
        state.tournaments.splice(index, 1);
      }
    },
    /**
     * remove category from favorites list
     * @param categoryId selected category id
     */
    removeFavoriteCategory(state, categoryId) {
      const index = state.categories.findIndex(c => c.categoryId === categoryId);
      if (index > -1) {
        state.categories.splice(index, 1);
      }
    },
    initFavorite(state) {
      const favorites = LocalStorageService.get('favorites');
      // get favorite tournaments & categories from local storage
      const tournaments = LocalStorageService.get('favoriteTournaments');
      const categories = LocalStorageService.get('favoriteCategories');
      const favSports = LocalStorageService.get('favoriteSports');
      if (Array.isArray(favorites)) {
        state.favorites = favorites;
      }
      if (Array.isArray(tournaments)) {
        state.tournaments = tournaments;
      }
      if (Array.isArray(categories)) {
        state.categories = categories;
      }
      if (Array.isArray(favSports)) {
        state.sports = favSports;
      }
    },
    updateFavoriteMatches(state, data) {
      state.favoriteMatches = data.map(m => new MatchDetailsPrematchModel(m));
    },
    setFavoriteMatches(state, data) {
      state.favoriteMatches = data;
    },
  },
  actions: {
    cleanOldFavorites({ commit, state }) {
      const dateNow = new Date().getTime();
      state.favorites.forEach((f) => {
        const daysDifference = Math.floor((dateNow - f.dateStarted) / 86400000);

        if (f.isLive && daysDifference > 1) {
          commit('removeFavorite', f.matchId);
        }

        if (daysDifference > 10) {
          commit('removeFavorite', f.matchId);
        }
      });
    },
    getFavoriteMatches({ commit, state }) {
      if (state.asyncFlagFavorites) {
        return;
      }
      const favoriteMatches = new MyFavoritesRequestService();
      commit('updateAsyncFlagFavorites', true);
      favoriteMatches.postParams.MatchIds = state.favorites.map(m => m.matchId);
      favoriteMatches.execute((resp) => {
        commit('updateAsyncFlagFavorites', false);
        if (!resp.data) {
          return;
        }
        commit('updateFavoriteMatches', resp.data);
      }, () => {
        commit('updateAsyncFlagFavorites', false);
      });
    },
    /**
     * On combo selection get the new outcomes and map them to the loaded matches.
     */
    changeFavoriteCombi({ state, commit }, payload) {
      const changeCombiRequest = new ChangeCombiService();
      changeCombiRequest.getParams.MatchData = state.favoriteMatches.map(match => match.matchId);
      changeCombiRequest.getParams.OddType = payload.oddType;
      changeCombiRequest.getParams.isMostBalanced = payload.isMostBalanced;
      changeCombiRequest.getParams.Outcomes = payload.outcomes.map(o => o.id);
      changeCombiRequest.execute((resp) => {
        const favorites = JSON.parse(JSON.stringify(state.favoriteMatches));
        favorites.forEach((item) => {
          let market = {
            id: payload.oddType,
            n: payload.name,
            m: resp.data !== null && typeof resp.data[item.matchId] !== 'undefined' ? resp.data[item.matchId][0].m :
              OddHelperService.generateEmptyOutcomes(payload.outcomes.length),
          };
          const idx = item.odds.findIndex(market => market.marketId === payload.oddType);
          if (idx >= 0) {
            item.odds[idx] = Object.assign({}, changeCombiRequest.mapOdds(market, item));
          } else {
            item.odds.push(changeCombiRequest.mapOdds(market, item));
          }
          item = Object.assign({}, item);
        });
        commit('setFavoriteMatches', favorites);
      });
    },
  },
  getters: {
    getFavoritesBetRadarMatchIds(state) {
      return state.favorites.map(m => m.betRadarId);
    },
    getFavoritesSportIds(state) {
      return state.favoriteMatches.map(m => m.sportId).sort((a, b) => a - b).reduce((unique, item) => unique.includes(item) ? unique : [...unique, item], []);
    },
    liveFavoriteSportIds(state) {
      return [...new Set(state.favorites.filter(m => m.isLive).map(m => m.sportId))];
    },
    hasLiveFavourites(state) {
      return state.favorites.some(m => m.isLive);
    },
  },
};
